import { Event, Meeting } from '@Hooks/Types'
import { capitalizeFirstLetter } from '@Lib/Util'


/**
 * Get the name of the meeting location
 *
 * @param {MeetingType} meeting - The meeting object containing location details
 * @returns {string} The formatted location name:
 *   - Returns meeting.location.name if available
 *   - Falls back to timeslot.location if location.name is not available
 *   - Falls back to 'Networking Area' if neither is available
 *   - Returns 'Custom location' if there is no timeslot and location
 */
export function getMeetingLocation(meeting: Meeting) {
  if (!meeting.timeslot && !meeting.location) {
    return 'Custom location'
  }

  return meeting.location?.name || meeting.timeslot?.location || 'Networking Area'
}

export function getMeetingTableIndex(meeting: Meeting, event: Event) {
  const { table } = meeting
  const tableNickname = capitalizeFirstLetter(event.tableNickname) || 'Table'
  return table?.tableIndex ? `${tableNickname} ${table?.tableIndex}` : null
}
